import { RegisterUploadVideoLinkedinMeta, RegisterUploadVideoLinkedinPayload } from 'types/store/RegisterUploadVideoLinkedin';
import { createAsyncReducer } from 'utils/Redux';

import { registerUploadVideoLinkedinActions } from '../actions';

export default createAsyncReducer<RegisterUploadVideoLinkedinMeta, RegisterUploadVideoLinkedinPayload>(registerUploadVideoLinkedinActions);
